module.exports = __webpack_public_path__ + "static/media/chess-king.0c471d1f.svg";